import { RichText } from 'prismic'

export const isRichTextBrief = (brief) => Array.isArray(brief)

export const hasBrief = (brief) => {
  if (!brief) return false
  if (isRichTextBrief(brief)) return brief.length > 0
  return Boolean(brief)
}

export const renderBrief = (brief) => {
  if (isRichTextBrief(brief)) return RichText.render(brief)
  return brief
}

export const getBriefParagraphs = (brief) => (typeof brief === 'string' ? brief.split(/\n\n+/).filter(Boolean) : [])
